import { InputsBuyerInfoProvider } from 'providers/InputsBuyerInfoProvider';
import { InputsFilterProvider } from './InputsFilterProvider';
import { InputsMarketProvider } from './InputsMarketProvider';
import { InputsStateProvider } from './InputsStateProvider';

const InputsProviderWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <InputsStateProvider>
      <InputsFilterProvider>
        <InputsMarketProvider>
          <InputsBuyerInfoProvider>{children}</InputsBuyerInfoProvider>
        </InputsMarketProvider>
      </InputsFilterProvider>
    </InputsStateProvider>
  );
};

export default InputsProviderWrapper;
